import React, { useState } from 'react';
import PropTypes from "prop-types";
import T from "i18n-react";
import clsx from 'clsx';

import CheckIcon from 'assets/icons/Check.svg';
import { Input } from 'components/Form';

import classes from './PasswordWithStrongField.module.scss';

const PasswordWithStrongField = props => {
    const { passwordProps = {} } = props;
    const { formProps, onChange, onPasswordStrong, className } = passwordProps;
    const { handleChange } = formProps;
    const [passwordStrong, setPasswordStrong] = useState([]);
    const getStrongPassword = (val) => {
        const passwordStr = val.trim();
        const pwdStrong = [];
        if (passwordStr.match(/[A-Z]/)) {
            if (pwdStrong.indexOf('upperChar') < 0) {
                pwdStrong.push('upperChar');
            }
        }
        if (passwordStr.match(/[a-z]/)) {
            if (pwdStrong.indexOf('lowerChar') < 0) {
                pwdStrong.push('lowerChar');
            }
        }
        if (passwordStr.match(/\d/) || passwordStr.match(/[(!@#$%^&*){}\-=_+[\]:;'",.<>]/)) {
            if (pwdStrong.indexOf('specialChar') < 0) {
                pwdStrong.push('specialChar');
            }
        }
        if (passwordStr.length >= 8) {
            if (pwdStrong.indexOf('minLength') < 0) {
                pwdStrong.push('minLength');
            }
        }
        onPasswordStrong(pwdStrong);
        setPasswordStrong(pwdStrong);
    }

    return (
        <div className={clsx(classes.wrapper, className)}>
            <div className={classes.passwordStrongDescription}>
                <p>{T.translate("password.strong.title")}</p>
                <ul>
                    <li className={passwordStrong.indexOf('upperChar') >= 0 ? classes.actived : ''}>{T.translate("password.strong.rule.upperChar")} <img src={CheckIcon} alt="check-icon" title="Checked" /></li>
                    <li className={passwordStrong.indexOf('lowerChar') >= 0 ? classes.actived : ''}>{T.translate("password.strong.rule.lowerChar")} <img src={CheckIcon} alt="check-icon" title="Checked" /></li>
                    <li className={passwordStrong.indexOf('specialChar') >= 0 ? classes.actived : ''}>{T.translate("password.strong.rule.specialChar")} <img src={CheckIcon} alt="check-icon" title="Checked" /></li>
                    <li className={passwordStrong.indexOf('minLength') >= 0 ? classes.actived : ''}>{T.translate("password.strong.rule.minLength")} <img src={CheckIcon} alt="check-icon" title="Checked" /></li>
                </ul>
                <p>
                    <i>{T.translate("password.example")}</i>
                </p>
            </div>
            <Input type="text" inputProps={{
                label: T.translate("login.userUpdatePassword.newPassword"),
                name: 'password',
                formProps,
                className: classes.textField,
                type: 'password',
                placeholder: T.translate("login.userUpdatePassword.newPassword"),
                onChange: (e) => {
                    handleChange(e);
                    onChange(e);
                    getStrongPassword(e.target.value);
                },
                isEyeVisibilityIcon: true,
            }} />
        </div>
    );
}

PasswordWithStrongField.propTypes = {
    passwordProps: PropTypes.object.isRequired,
};

export default PasswordWithStrongField;
